import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateBOLPDF = async (bolData) => {
    // Create new PDF document
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'letter'
    });

    // Set default font
    doc.setFont('helvetica');

     // Logo configuration
     const logoPath = '/img/j-logo.png';
     const logoWidth = 15;
     const logoHeight = 25;
     
     // Add logo
     try {
         const logo = await fetch(logoPath)
             .then((res) => res.blob())
             .then((blob) => {
                 return new Promise((resolve, reject) => {
                     const reader = new FileReader();
                     reader.onload = () => resolve(reader.result);
                     reader.onerror = reject;
                     reader.readAsDataURL(blob);
                 });
             });
         doc.addImage(logo, 'PNG', 15, 10, logoWidth, logoHeight);
     } catch (error) {
         console.error('Error loading logo image:', error);
         // Continue generating PDF without logo
     }

    // Header section
    doc.setFontSize(12);
    doc.text('BW-CA-16742', 35, 13);
    doc.setFontSize(20);
    doc.text('Straight Bill of Lading', 35, 21);
    doc.setFontSize(12);
    doc.text('Short Form - Original - Not Negotiable', 35, 28);
    doc.text(`Tax Status: ${bolData.bolTAX}`, 35, 34);
    
    // Add date and BOL number
    doc.setFontSize(12);
    const formattedDate = new Date(bolData.bolShipdate).toLocaleDateString();
    doc.text(`Date: ${formattedDate}`, 160, 28);
    doc.setFontSize(16);
    doc.text(`No: ${new Date().getFullYear()}-${bolData.bolID}`, 160, 21);

    // Add vertical line
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.04);
    doc.line(155, 30, 155, 15);

    // Company Information Section
       // Company Information Section
       const companyInfoY = 50;
    
// Helper function to draw a header with grey background of fixed width
    const drawHeaderWithBackground = (doc, text, x, y) => {
        const fixedWidth = 55; // Fixed width for all header backgrounds
        const padding = 2; // Padding around text
        
        // Draw grey background rectangle
        doc.setFillColor(245, 245, 245);
        doc.rect(x - padding, y - 5, fixedWidth, 7, 'F');
        
        // Draw text
        doc.text(text, x, y);
    };

    // Shipper Info
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    drawHeaderWithBackground(doc, 'Shipper:', 15, companyInfoY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text([
        bolData.shipperName,
        bolData.shipperAddress,
        `${bolData.shipperCity}, ${bolData.shipperState} ${bolData.shipperZip}`,
        bolData.shipperPhone
    ], 15, companyInfoY + 7);

    // Carrier Info
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    drawHeaderWithBackground(doc, 'Carrier:', 80, companyInfoY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text([
        bolData.carrierName,
        bolData.carrierAddress,
        `${bolData.carrierCity}, ${bolData.carrierState} ${bolData.carrierZip}`,
        bolData.carrierPhone
    ], 80, companyInfoY + 7);

    // Consignee Info
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    drawHeaderWithBackground(doc, 'Consignee:', 145, companyInfoY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text([
        bolData.consigneeName,
        bolData.consigneeAddress,
        `${bolData.consigneeCity}, ${bolData.consigneeState} ${bolData.consigneeZip}`,
        bolData.consigneePhone
    ], 145, companyInfoY + 7);

    // Items Table
    const getAlcoholText = (proAlc) => {
        if (proAlc > 16) return "Over 16% Alc.";
        if (proAlc > 14) return "Over 14% Alc.";
        return "Under 14% Alc.";
    };

    const tableData = bolData.items.map(item => [
        item.quantity.toString(),
        `${item.proVintage} ${item.proBrand} ${item.proVarietal} ${item.proFanciful} ${item.proPack}x${item.proLiters ? (item.proLiters * 1000).toFixed(0) : '0'} ML - ${getAlcoholText(item.proAlc)} | ${item.bolItemGalSum} Gal.\n${item.proWineType || ''} | ${item.proAppellation || ''}`,
        `${item.bolWeightSub} Lbs`
    ]);

    // Add the items table
    doc.autoTable({
        startY: 85,
        head: [['Qnty.', 'Description (Contains Sulfites)', 'Weight']],
        body: tableData,
        theme: 'grid',
        styles: {
            fontSize: 9,
            cellPadding: 2,
        },
        headStyles: {
            fillColor: [245, 245, 245], // Light grey background
            textColor: [0, 0, 0], // Black text
            fontStyle: 'bold'
        },
        footStyles: {
            fillColor: [245, 245, 245], // Light grey background
            textColor: [0, 0, 0], // Black text
            fontStyle: 'bold'
        },
        columnStyles: {
            0: { cellWidth: 20 },
            1: { cellWidth: 135 },
            2: { cellWidth: 30 }
        },
        foot: [[
            `Items: ${bolData.bolTotalItems}`,
            'Total Weight:',
            `${bolData.bolTotalWeight} lbs`
        ]],
        didDrawPage: function(data) {
            // Add page number at the bottom
            doc.setFontSize(8);
            doc.text(
                `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${doc.internal.getNumberOfPages()}`,
                data.settings.margin.left,
                doc.internal.pageSize.height - 10
            );
    
            // If this is not the first page, add a continuation header
            if (doc.internal.getCurrentPageInfo().pageNumber > 1) {
                doc.setFontSize(12);
                doc.text(
                    `Bill of Lading ${bolData.bolID} (Continued)`,
                    data.settings.margin.left,
                    20
                );
                doc.setFontSize(10);
                doc.text(
                    `Date: ${new Date(bolData.bolShipdate).toLocaleDateString()}`,
                    data.settings.margin.left,
                    30
                );
            }
        },
        margin: { top: 40 }
    });

    // Add Instructions
    const finalY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text('Instructions:', 15, finalY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(bolData.bolInstructions || 'None', 15, finalY + 7);

    // Add Terms
    doc.setFontSize(8);
    const terms = 'RECEIVED, subject to applicable classifications and tariffs, the property described above in apparent good order except as noted. This shipment is subject to the terms and conditions of the Uniform Domestic Straight Bill of Lading, as applicable. The shipper certifies the accuracy of the information provided and agrees to the conditions herein. Delivery is subject to payment of freight and other lawful charges.';
    doc.text(terms, 15, finalY + 20, { maxWidth: 180 });

    // Add signature lines
    const sigY = finalY + 40;
    doc.setFontSize(10);
    
    // Shipper signature
    doc.text('X', 20, sigY);
    doc.line(25, sigY, 65, sigY);
    doc.text('SHIPPER', 35, sigY + 5);

    // Carrier signature
    doc.text('X', 80, sigY);
    doc.line(85, sigY, 125, sigY);
    doc.text('CARRIER', 95, sigY + 5);

    // Consignee signature
    doc.text('X', 140, sigY);
    doc.line(145, sigY, 185, sigY);
    doc.text('CONSIGNEE', 155, sigY + 5);

    // Save the PDF
    doc.save(`BOL-${bolData.bolID}.pdf`);
};